export interface RealtimeTokenResponse {
  jwt: string;
  websocketUrl: string;
  expiresAtUtc: string;
}

export interface SummarizeResponse {
  summary: string;
}

const BASE = "ai-speech-to-text";

async function parseJsonResponse<T>(response: Response): Promise<T | null> {
  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) return null;
  try {
    return (await response.json()) as T;
  } catch {
    return null;
  }
}

class AiSpeechToTextApi {
  constructor(private accessToken: string | undefined) {}

  async getRealtimeToken(): Promise<RealtimeTokenResponse | "RATE_LIMITED" | "FORBIDDEN" | null> {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/${BASE}/realtime-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        },
      );

      if (response.status === 429) return "RATE_LIMITED";
      if (response.status === 403) return "FORBIDDEN";
      if (!response.ok) return null;

      return parseJsonResponse<RealtimeTokenResponse>(response);
    } catch {
      return null;
    }
  }

  async summarize(
    text: string,
  ): Promise<SummarizeResponse | "RATE_LIMITED" | null> {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/${BASE}/summarize`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify({ text }),
        },
      );

      if (response.status === 429) return "RATE_LIMITED";
      if (!response.ok) return null;

      return parseJsonResponse<SummarizeResponse>(response);
    } catch {
      return null;
    }
  }
}

export default AiSpeechToTextApi;
